import { Component, HostBinding, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { debounceTime, Subscription, tap } from 'rxjs';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-toasts',
  template: `
  <div  *ngFor="let toast of toasts" >
    <h3>{{toast.header}}</h3>
    {{ toast.body }}
  </div>
  `,
  host: { '[class.ngb-toasts]': 'false' }
})
export class ToastsComponent implements OnInit, OnDestroy {
  toastsSub: Subscription;
  showToasts: boolean;
  toasts: any[] = [];
  public get hasSomeToasts(): boolean {
    return this.toasts.length > 0;
  }

  constructor(public toastService: ToastService) {
    this.toastsSub = this.toastService.toasts$.pipe(
      debounceTime(500),
      tap(toasts => {
       
        this.toasts = toasts;
        this.showToasts = true;

      }),
      debounceTime(3000), tap(toasts => { this.showToasts = false; }),
      debounceTime(2000), tap(toasts => {
        this.toastService.clear();
      })

    ).subscribe();
  }
  ngOnDestroy(): void {
    this.toastsSub.unsubscribe();
  }

  hasTemplate(toast) {
    if (toast.templateRef == null) return false;
    return toast.templateRef instanceof TemplateRef;
  }
  ngOnInit(): void {

  }


  @HostBinding('class')
  get classes(): string {
    return this.showToasts ? 'toastsVisible' : 'toastsHidden';
  }
}
